import React from "react";
import { LeagueHeaderWithCurrentUserAssignment } from "../../store/leagues/models";
import { Data } from "../../framework/data";
import CircularProgress from "@material-ui/core/CircularProgress";
import LeagueCityGroup from "./LeagueCityGroup";

interface ILeagueGroupsProps {
    groups: Data<{[city:string]:LeagueHeaderWithCurrentUserAssignment[]}>
}

const LeagueGroups: React.FC<ILeagueGroupsProps> = ({ groups }) => {

    switch(groups.type) {
        case "LOADED": {

            const toRender = Object.entries(groups.value).map(([city, leagues]) => (<LeagueCityGroup key={city} city={city} leagues={leagues} ></LeagueCityGroup>));

            return (<div>{toRender}</div>)
        }
        case "LOADING": {
            return (<div style={{ width: '64px', height: '64px', marginLeft: 'auto', marginRight: 'auto'}}><CircularProgress /></div>)
        }
        default: {
            return(<div></div>);
        } 
    }
}

export default LeagueGroups;